import { render, staticRenderFns } from "./VincularTecnicoEdit.vue?vue&type=template&id=324a637d&scoped=true&"
import script from "./VincularTecnicoEdit.vue?vue&type=script&lang=js&"
export * from "./VincularTecnicoEdit.vue?vue&type=script&lang=js&"
import style0 from "./VincularTecnicoEdit.vue?vue&type=style&index=0&id=324a637d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a637d",
  null
  
)

export default component.exports